import React from 'react';
import { Link } from 'react-router-dom';
import { QrCode, ArrowLeft } from 'lucide-react';

const CGU = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900">
            <ArrowLeft className="h-4 w-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
            <QrCode className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-gray-900">Conditions Générales d'Utilisation</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-soft p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 1 - Objet</h2>
            <p className="text-gray-600">
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités 
              et conditions d'utilisation du service ZOTMENU, édité par la SARL DEALRUN (SIRET : 895 350 783 00018).
              ZOTMENU est une plateforme SaaS permettant aux restaurateurs de créer et gérer un menu digital 
              accessible via QR Code.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 2 - Acceptation des CGU</h2>
            <p className="text-gray-600">
              L'utilisation du service ZOTMENU implique l'acceptation pleine et entière des présentes CGU. 
              En créant un compte, l'utilisateur reconnaît avoir lu, compris et accepté l'intégralité des 
              présentes conditions.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 3 - Description du service</h2>
            <div className="text-gray-600 space-y-2">
              <p>ZOTMENU propose les fonctionnalités suivantes :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Création et gestion d'un menu digital</li>
                <li>Génération de QR Code personnalisé</li>
                <li>Statistiques de consultation du menu</li>
                <li>Assistant IA pour l'optimisation des ventes (selon abonnement)</li>
                <li>Personnalisation de l'apparence du menu</li>
                <li>Gestion des catégories, plats et promotions</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 4 - Inscription et compte</h2>
            <div className="text-gray-600 space-y-2">
              <p>Pour utiliser ZOTMENU, l'utilisateur doit :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Être une personne morale ou physique exerçant une activité de restauration</li>
                <li>Créer un compte en fournissant des informations exactes et complètes</li>
                <li>Choisir un abonnement adapté à ses besoins</li>
                <li>Maintenir la confidentialité de ses identifiants de connexion</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 5 - Abonnements et tarifs</h2>
            <div className="text-gray-600 space-y-2">
              <p>ZOTMENU propose trois formules d'abonnement :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Starter (19€/mois)</strong> : Menu digital, QR Code, statistiques de base</li>
                <li><strong>Essentiel (39€/mois)</strong> : Inclut l'Assistant IA, thèmes personnalisés, analytics avancés</li>
                <li><strong>Premium (59€/mois)</strong> : Inclut les commandes à emporter, bipper digital, notifications</li>
              </ul>
              <p className="mt-4">
                Une période d'essai gratuite de 60 jours est proposée à l'inscription. 
                Les abonnements sont sans engagement et peuvent être résiliés à tout moment.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 6 - Obligations de l'utilisateur</h2>
            <div className="text-gray-600 space-y-2">
              <p>L'utilisateur s'engage à :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Utiliser le service conformément à sa destination</li>
                <li>Ne pas publier de contenu illicite, diffamatoire ou contraire aux bonnes mœurs</li>
                <li>Respecter les droits de propriété intellectuelle</li>
                <li>Ne pas tenter de perturber le fonctionnement du service</li>
                <li>Informer ZOTMENU de tout problème de sécurité détecté</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 7 - Propriété des données</h2>
            <p className="text-gray-600">
              L'utilisateur reste propriétaire de toutes les données qu'il saisit sur la plateforme 
              (menus, descriptions, images, etc.). ZOTMENU s'engage à ne pas utiliser ces données 
              à d'autres fins que la fourniture du service, sauf accord explicite de l'utilisateur.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 8 - Résiliation</h2>
            <div className="text-gray-600 space-y-2">
              <p>L'utilisateur peut résilier son abonnement à tout moment depuis son espace client ou en contactant le support.</p>
              <p>ZOTMENU se réserve le droit de suspendre ou résilier un compte en cas de :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Non-respect des présentes CGU</li>
                <li>Non-paiement de l'abonnement</li>
                <li>Utilisation frauduleuse du service</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 9 - Limitation de responsabilité</h2>
            <p className="text-gray-600">
              ZOTMENU met tout en œuvre pour assurer la disponibilité et le bon fonctionnement du service. 
              Toutefois, ZOTMENU ne saurait être tenu responsable des interruptions de service, 
              des pertes de données ou des dommages indirects liés à l'utilisation du service.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 10 - Modification des CGU</h2>
            <p className="text-gray-600">
              ZOTMENU se réserve le droit de modifier les présentes CGU à tout moment. 
              Les utilisateurs seront informés de toute modification par email ou notification sur la plateforme. 
              La poursuite de l'utilisation du service après modification vaut acceptation des nouvelles CGU.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 11 - Droit applicable et juridiction</h2>
            <p className="text-gray-600">
              Les présentes CGU sont régies par le droit français. En cas de litige, les parties s'efforceront 
              de trouver une solution amiable. À défaut, les tribunaux compétents seront ceux du ressort 
              du siège social de SARL DEALRUN.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">Article 12 - Contact</h2>
            <div className="text-gray-600">
              <p>Pour toute question concernant ces CGU :</p>
              <p className="mt-2">
                <strong>Email :</strong> <a href="mailto:contact@dealrun.re" className="text-orange-500 hover:underline">contact@dealrun.re</a><br />
                <strong>Téléphone :</strong> <a href="tel:0693463628" className="text-orange-500 hover:underline">06 93 46 36 28</a>
              </p>
            </div>
          </section>
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          Dernière mise à jour : Janvier 2025
        </p>
      </main>
    </div>
  );
};

export default CGU;
